import {type ClassValue, clsx} from 'clsx'
import {twMerge} from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/** Round to 4 decimal places (LVS PDF precision: 1.0000) */
export function round4(n: number): string {
    return n.toFixed(4)
}

/**
 * LVS standarta atsauces formatējums.
 *
 *   lvsRef('9.20', 'clause')  → '9.20.'
 *   lvsRef('9.1',  'picture') → '9.1. att.'
 *   lvsRef('9.14', 'table')   → '9.14. tab.'
 *
 * Value is accepted as `string` to preserve trailing zeros (e.g. `9.20`,
 * which as a `number` would stringify to `'9.2'`). Numbers are also
 * accepted for convenience.
 */
export type LvsRefType = 'clause' | 'picture' | 'table'

export function lvsRef(value: string | number, type: LvsRefType): string {
    const n = typeof value === 'number' ? String(value) : value
    switch (type) {
        case 'clause':
            return `${n}.`
        case 'picture':
            return `${n}. att.`
        case 'table':
            return `${n}. tab.`
    }
}
